import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function ViewPendingProducts({ selectProduct }) {
  const [isLoading, setIsLoading] = useState(false);
  const [subscription, setSubscription] = useState([]);
  const [payAsGo, setPayAsGo] = useState([]);

  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  const ConvertToCurrency = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  });

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const prodResponse = await axios.get(
        `${ApiConnectionString}/api/MyPendingProducts`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setSubscription(prodResponse.data.filter((p) => p.recurring));
      setPayAsGo(prodResponse.data.filter((p) => !p.recurring));
    } catch (error) {
      if (error.status === 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;
    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [user]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="mt-4">
  

      <div className="bg-white rounded shadow-sm p-3 mb-4">
        <h5 className="fw-bold">Subscriptions</h5>
        {subscription.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Name</th>
                  <th>Interval</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {subscription.map((prod) => (
                  <tr
                    key={prod.id}
                    className="table-row-hover"
                    onClick={() => selectProduct(prod.id, "ViewOneProduct")}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{prod.name}</td>
                    <td>{prod.interval}</td>
                    <td>{ConvertToCurrency.format(prod.price / 100)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-muted">No subscription products found.</p>
        )}
      </div>

      <div className="bg-white rounded shadow-sm p-3">
        <h5 className="fw-bold">Flexible Class Packs</h5>
        {payAsGo.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Name</th>
                  <th>Classes</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {payAsGo.map((prod) => (
                  <tr
                    key={prod.id}
                    className="table-row-hover"
                    onClick={() => selectProduct(prod.id, "ViewOneProduct")}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{prod.name}</td>
                    <td>{prod.classToken}</td>
                    <td>{ConvertToCurrency.format(prod.price / 100)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-muted">No Flexible Class Pack products found.</p>
        )}
      </div>
    </div>
  );
}
